module.exports = __webpack_public_path__ + "static/1-ec43515a8608d9eed2bc95cc654d2b89.png";